module.exports = __webpack_public_path__ + "static/media/drone_cube.4fdc96cf.avif";